// extracted by mini-css-extract-plugin
export default {"container":"Tabs_container__tZQz8","tab":"Tabs_tab__DsW2m","tabItemActive":"Tabs_tabItemActive__wBEUH","warningIcon":"Tabs_warningIcon__E5gF0"};